/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from "react";
import {
  Container,
  List,
  Segment,
  Grid,
  //GridRow,
  GridColumn,
  //Icon,
  //Button,
  //ButtonContent,
} from "semantic-ui-react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { UniversalLink } from "@plone/volto/components";

import { useGoogleAnalytics } from "volto-google-analytics";
const messages = defineMessages({
  copyright: {
    id: "Copyright",
    defaultMessage: "Copyright",
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  useGoogleAnalytics();
  return (
    <div className="footer-container print_hide">
      <Segment
        role="contentinfo"
        vertical
        padded
        inverted
        id="footer"
        aria-label="Footer"
      >
        <div>
          <div id="footer-main">
            <Grid padded stackable>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>About</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/about-us/about-the-institute/about-the-institute">
                        About us
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about-us/history/origins">
                        History
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about-us/about-the-institute/our-people">
                        Our people
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about-us/omar-memorial-lecture/omar-memorial-lecture">
                        The Dullah Omar Memorial Lecture
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
                <List>
                  <List.Header>
                    <h4>News & Events</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/news-and-events/news">
                        News
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/news-and-events/events">
                        Events
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>Our work</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/our-work/acjr">
                        Africa Criminal Justice Reform
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/our-work/multilevel-govt">
                        Multilevel Government
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/our-work/socio-economic-rights">
                        Socio-Economic Rights Project
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/our-work/childrens-rights">
                        The Children's Rights Project (CRP)
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                  <List.Header>
                    <h4>Publications</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/our-work/multilevel-govt/local-government-bulletin">
                        Local Government Bulletin
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/our-work/socio-economic-rights/esr-review-archives">
                        ESR Review
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/our-work/acjr/acjr-publications">
                        ACJR Publications
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/our-work/multilevel-govt/publications">
                        MLG Publications
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>Quick links</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink
                        href="https://www.uwc.ac.za/privacy-policy"
                        target="_blank"
                      >
                        Privacy policy
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink
                        href="/files/terms-conditions.pdf/@@download/file"
                        target="_blank"
                      >
                        Terms of use
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink
                        target="_blank"
                        href="/files/constitution-doi-2022.pdf/@@download/file"
                      >
                        DOI Constitution
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/contact-us">
                        Contact us
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={6} textAlign="right" verticalAlign="bottom">
                <List>
                  <List.Content>
                    <List.Item className="footer-sitesocial">
                      <List horizontal>
                        <List.Item>
                          <UniversalLink
                            href="https://www.linkedin.com/company/dullah-omar-institute/"
                            target="_blank"
                            title="LinkedIn"
                          >
                            <i className="bi bi-linkedin"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.facebook.com/CommunityLawCentre/"
                            target="_blank"
                            title="Facebook"
                          >
                            <i className="bi bi-facebook"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.youtube.com/channel/UC8kJ7f_Ty1fDdH1biwQdLCQ"
                            target="_blank"
                            title="YouTube"
                          >
                            <i className="bi bi-youtube"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://twitter.com/UWC_DOI"
                            target="_blank"
                            title="X"
                          >
                            <i className="bi bi-twitter-x"></i>
                          </UniversalLink>
                        </List.Item>
                      </List>
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      <FormattedMessage
                        id="{copyright} Dullah Omar Institute {current_year}"
                        defaultMessage="{copyright} Dullah Omar Institute {current_year}"
                        values={{
                          copyright: (
                            <abbr
                              title={intl.formatMessage(messages.copyright)}
                            >
                              ©
                            </abbr>
                          ),
                          current_year: new Date().getFullYear(),
                        }}
                      />
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      Stock images/videos courtesy of{" "}
                      <a href="https://www.pexels.com" target="_blank">
                        Pexels
                      </a>{" "}
                      &{" "}
                      <a href="https://unsplash.com" target="_blank">
                        Unsplash
                      </a>
                    </List.Item>
                    <List.Item>
                      <UniversalLink
                        href="#top"
                        className="header-link"
                        title="Back to top"
                      >
                        <i className="bi bi-arrow-up-square"></i>
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
            </Grid>
          </div>
        </div>
      </Segment>
      <div className="belowFooter">
        <a href="https://juizi.com" target="_blank">
          <img src="https://juizi.com/juizi.png" />
        </a>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
